import { SelectOption } from '@/lib/Selects/Select/types';
import { PerformanceAudienceFilterOption } from '@/services/endpoints/performanceAudience';
import { TFunction } from 'i18next';

export const DATE_RANGE_FILTER_IDS = new Set(['last_7_days', 'last_14_days', 'last_30_days']);

export const getFilterOptionDisplayLabel = (
  option: PerformanceAudienceFilterOption,
  t: TFunction<'performanceAudience'>
): string => {
  if (DATE_RANGE_FILTER_IDS.has(option.id)) {
    return t(`filters.${option.id}`);
  }

  return option.menuLabel ?? [option.value, option.suffix].filter(Boolean).join(' ');
};

export const toFilterMenuOptions = (
  items: PerformanceAudienceFilterOption[],
  t: TFunction<'performanceAudience'>
): SelectOption[] =>
  items.map((item) => ({
    id: item.id,
    label: getFilterOptionDisplayLabel(item, t),
  }));

export const findFilterOption = (items: PerformanceAudienceFilterOption[], id: string) =>
  items.find((item) => item.id === id) ?? null;
